import { render, staticRenderFns } from "./ProjectSummaryBacker.vue?vue&type=template&id=338004c0"
import script from "./ProjectSummaryBacker.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryBacker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports